// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"folder-details"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M2 3.5L9 3.5L11 6L22 6L22 20L2 20L2 3.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2 3.5H9L11 6H22V20H2V3.5Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M11.998 12.998H12.002V13.002H11.998V12.998Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M7.99805 12.998H8.00195V13.002H7.99805V12.998Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M15.998 12.998H16.002V13.002H15.998V12.998Z","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-folder-details')
export default class FolderDetailsIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-details',
    }
  }
}
